import React, { createContext, useContext, useState, ReactNode } from 'react';
import { MakeGoodSuggestionResponse, PreEmptedSpot } from '../components/types';

type MakeGoodContextType = {
  offerCreated: boolean;
  setOfferCreated: (status: boolean) => void;
  currentPreEmptedSpot: PreEmptedSpot;
  setCurrentPreEmptedSpot: (preEmptedSpot: PreEmptedSpot) => void;
  preEmptedSpotDetails: MakeGoodSuggestionResponse | undefined;
  setPreEmptedSpotDetails: (response: any) => void;
  preEmptedSpotList: PreEmptedSpot[];
  setPreEmptedSpotList: (response: any) => void;
};

const MakeGoodContext = createContext<MakeGoodContextType | undefined>(
  undefined
);

export const MakeGoodProvider = ({ children }: { children: ReactNode }) => {
  const [offerCreated, setOfferCreated] = useState(false);
  const [currentPreEmptedSpot, setCurrentPreEmptedSpot] =
    useState<PreEmptedSpot>({} as PreEmptedSpot);
  const [preEmptedSpotDetails, setPreEmptedSpotDetails] = useState<
    MakeGoodSuggestionResponse | undefined
  >(undefined);
  const [preEmptedSpotList, setPreEmptedSpotList] = useState<PreEmptedSpot[]>(
    []
  );

  return (
    <MakeGoodContext.Provider
      value={{
        offerCreated,
        setOfferCreated,
        currentPreEmptedSpot,
        setCurrentPreEmptedSpot,
        preEmptedSpotDetails,
        setPreEmptedSpotDetails,
        preEmptedSpotList,
        setPreEmptedSpotList,
      }}
    >
      {children}
    </MakeGoodContext.Provider>
  );
};

export const useMakeFoodRecommendation = () => {
  const context = useContext(MakeGoodContext);
  if (!context) {
    throw new Error('useCreateOffer must be used within a CreateOfferProvider');
  }
  return context;
};
